import { Check } from "lucide-react";
import { useId } from "react";
import { cn } from "../../lib/cn";

const sizes = {
  sm: "h-3.5 w-3.5 rounded-[3px]",
  md: "h-4 w-4 rounded-[4px]",
  lg: "h-5 w-5 rounded-[5px]",
};

const iconSizes = {
  sm: 9,
  md: 11,
  lg: 13,
};

export function Checkbox({
  id,
  checked,
  defaultChecked,
  onChange,
  onCheckedChange,
  disabled,
  className,
  boxClassName,
  labelClassName,
  size = "md",
  align = "center",
  children,
  ...props
}) {
  const autoId = useId();
  const inputId = id ?? autoId;

  const handleChange = (event) => {
    onChange?.(event);
    onCheckedChange?.(event.target.checked);
  };

  return (
    <label
      htmlFor={inputId}
      className={cn(
        "group inline-flex gap-2.5 cursor-pointer select-none",
        align === "start" && "items-start",
        align === "center" && "items-center",
        disabled && "cursor-not-allowed opacity-60",
        className
      )}
    >
      <span
        className={cn(
          "relative inline-flex shrink-0",
          align === "start" && "mt-0.5"
        )}
      >
        <input
          id={inputId}
          type="checkbox"
          className="sr-only"
          checked={checked}
          defaultChecked={defaultChecked}
          onChange={handleChange}
          disabled={disabled}
          {...props}
        />
        <span
          aria-hidden
          className={cn(
            "flex items-center justify-center border border-border bg-card transition-colors",
            "group-has-[:checked]:border-brand group-has-[:checked]:bg-brand",
            "group-has-[:focus-visible]:ring-2 group-has-[:focus-visible]:ring-ring group-has-[:focus-visible]:ring-offset-2",
            sizes[size] || sizes.md,
            boxClassName
          )}
        >
          <Check
            size={iconSizes[size] || iconSizes.md}
            strokeWidth={3}
            className="text-white opacity-0 scale-75 transition-all group-has-[:checked]:opacity-100 group-has-[:checked]:scale-100"
          />
        </span>
      </span>
      {children != null ? (
        <span className={cn("min-w-0 text-sm text-foreground", labelClassName)}>
          {children}
        </span>
      ) : null}
    </label>
  );
}
